import type { TFunction } from 'i18next';
import type { Report } from '../../types/report';

interface GetReporterDisplayOptions {
  includeEmailFallback?: boolean;
}

export function getReporterDisplay(
  report: Report,
  t: TFunction,
  options?: GetReporterDisplayOptions
): string {
  if (report.reporter) {
    return `${report.reporter.first_name} ${report.reporter.last_name ?? ''}`.trim();
  }

  if (options?.includeEmailFallback && report.reporter_email) {
    return report.reporter_email;
  }

  return t('issue.anonymous_reporter', { ns: 'reports' });
}
